import type { ProductPlanI18nFormModel } from "../../../../../type";
import type { ServerModel } from "../../type";

export const serverModelToInputModelConverter = (serverModel: ServerModel): ProductPlanI18nFormModel["InputModel"] => {
	const { planI18n, planCustomMailSettingI18n } = serverModel;
	const inputModel: ProductPlanI18nFormModel["InputModel"] = {
		hotelID: planI18n.hotelID,
		planID: planI18n.planID,
		lang: planI18n.lang,

		name: planI18n.name,
		mainTarget: planI18n.mainTarget,

		emailTemplateReservation: planI18n.emailTemplateReservation,

		questions: planI18n.questions,

		// カスタムメール設定（デフォルト設定からフォールバック）
		atCreated: {
			text: planCustomMailSettingI18n?.forReservation?.atCreated?.text ?? "",
			override: planCustomMailSettingI18n?.forReservation?.atCreated?.override ?? false,
		},
		atUpdated: {
			text: planCustomMailSettingI18n?.forReservation?.atUpdated?.text ?? "",
			override: planCustomMailSettingI18n?.forReservation?.atUpdated?.override ?? false,
		},
		atCanceled: {
			text: planCustomMailSettingI18n?.forReservation?.atCanceled?.text ?? "",
			override: planCustomMailSettingI18n?.forReservation?.atCanceled?.override ?? false,
		},
		atCheckInBefore_00days: {
			text: planCustomMailSettingI18n?.forReservation?.atCheckInBefore_00days?.text ?? "",
			override: planCustomMailSettingI18n?.forReservation?.atCheckInBefore_00days?.override ?? false,
			shouldSendEmail:
				planCustomMailSettingI18n?.forReservation?.atCheckInBefore_00days?.shouldSendEmail ?? false,
		},
		atCheckInBefore_01days: {
			text: planCustomMailSettingI18n?.forReservation?.atCheckInBefore_01days?.text ?? "",
			override: planCustomMailSettingI18n?.forReservation?.atCheckInBefore_01days?.override ?? false,
			shouldSendEmail:
				planCustomMailSettingI18n?.forReservation?.atCheckInBefore_01days?.shouldSendEmail ?? false,
		},
		atCheckInBefore_07days: {
			text: planCustomMailSettingI18n?.forReservation?.atCheckInBefore_07days?.text ?? "",
			override: planCustomMailSettingI18n?.forReservation?.atCheckInBefore_07days?.override ?? false,
			shouldSendEmail:
				planCustomMailSettingI18n?.forReservation?.atCheckInBefore_07days?.shouldSendEmail ?? false,
		},
		atCheckOutAfter_01days: {
			text: planCustomMailSettingI18n?.forReservation?.atCheckOutAfter_01days?.text ?? "",
			override: planCustomMailSettingI18n?.forReservation?.atCheckOutAfter_01days?.override ?? false,
			shouldSendEmail:
				planCustomMailSettingI18n?.forReservation?.atCheckOutAfter_01days?.shouldSendEmail ?? false,
		},
	} satisfies ProductPlanI18nFormModel["InputModel"];

	return inputModel;
};
